export default __webpack_public_path__ + "static/media/pinoff.1b18cc8b.svg";